"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLanguage = getLanguage;
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

var _vue = _interopRequireDefault(require("vue"));

var _vueI18n = _interopRequireDefault(require("vue-i18n"));

var _en = _interopRequireDefault(require("element-ui/lib/locale/lang/en"));

var _zhCN = _interopRequireDefault(require("element-ui/lib/locale/lang/zh-CN"));

var _zhTW = _interopRequireDefault(require("element-ui/lib/locale/lang/zh-TW"));

var _en2 = _interopRequireDefault(require("./en"));

var _zh_CN = _interopRequireDefault(require("./zh_CN"));

var _zh_TW = _interopRequireDefault(require("./zh_TW"));

// import localStorage from 'js-cookie'
// element-ui lang
// element-ui lang
// element-ui lang
_vue.default.use(_vueI18n.default);

var messages = {
  en: (0, _objectSpread2.default)({}, _en2.default, {}, _en.default),
  zh_CN: (0, _objectSpread2.default)({}, _zh_CN.default, {}, _zhCN.default),
  zh_TW: (0, _objectSpread2.default)({}, _zh_TW.default, {}, _zhTW.default)
};

function getLanguage() {
  var chooseLanguage = localStorage.getItem('language');
  if (chooseLanguage) return chooseLanguage; // if has not choose language

  var language = (navigator.language || navigator.browserLanguage).toLowerCase();
  var locales = Object.keys(messages);

  for (var _i = 0, _locales = locales; _i < _locales.length; _i++) {
    var locale = _locales[_i];

    if (language.indexOf(locale) > -1) {
      return locale;
    }
  }

  return 'en';
}

var i18n = new _vueI18n.default({
  // set locale
  // options: en | zh | es
  locale: getLanguage(),
  // set locale messages
  messages: messages
});
var _default = i18n;
exports.default = _default;